module.exports = __webpack_public_path__ + "static/media/rightarrow.aafd586d.webp";